import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';
import LegalModal from './LegalModal';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('wayo-cookie-consent');
    if (!cookieConsent) {
      // Small delay before showing banner for better UX
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('wayo-cookie-consent', 'accepted');
    setShowBanner(false);
    // Enable analytics/advertising cookies here if needed
  };

  const handleReject = () => {
    localStorage.setItem('wayo-cookie-consent', 'rejected');
    setShowBanner(false);
    // Disable non-essential cookies here if needed
  };

  const handleLearnMore = (e) => {
    e.preventDefault();
    setShowPrivacyModal(true);
  };

  return (
    <>
      {showBanner && (
        <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-500">
          <div className="bg-[#252525] border-t-4 border-[#FFD12D] shadow-2xl">
            <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                {/* Cookie Icon and Text */}
                <div className="flex items-start sm:items-center gap-3 flex-1">
                  <div className="w-10 h-10 rounded-full bg-[#FFD12D] flex items-center justify-center flex-shrink-0">
                    <Cookie className="w-5 h-5 text-[#252525]" />
                  </div>
                  <div className="text-white">
                    <p className="text-sm sm:text-base">
                      We use cookies to enhance your experience, serve personalised ads, and analyse our traffic. 
                      By clicking "Accept", you consent to our use of cookies. 
                      <button 
                        onClick={handleLearnMore}
                        className="text-[#FFD12D] hover:underline ml-1 font-semibold"
                      >
                        Learn more
                      </button>
                    </p>
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex items-center gap-3 flex-shrink-0">
                  <Button
                    onClick={handleReject}
                    variant="outline"
                    className="border-2 border-gray-500 text-white hover:bg-gray-700 hover:border-gray-400 font-semibold px-6 h-10 transition-all duration-300"
                  >
                    Reject
                  </Button>
                  <Button
                    onClick={handleAccept}
                    className="bg-[#FFD12D] hover:bg-white text-[#252525] font-semibold px-6 h-10 transition-all duration-300"
                  >
                    Accept
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <LegalModal
        type="privacy"
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
      />
    </>
  );
};

export default CookieConsent;
